(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('campaignPayoutService', campaignPayoutService);

  function campaignPayoutService(
    $http,
    campaignServiceNew
  ) {
    'ngInject';

    const service = {
      batchUpdatePayoutSettings: batchUpdatePayoutSettings
    };

    return service;

    function batchUpdatePayoutSettings(accountId, campaignId, payoutSettings, notifyPubs) {
      const url = _getBaseUrl(accountId, campaignId);
      const data = {
        allPayouts: payoutSettings,
        sendNotifications: notifyPubs
      };
      return $http.put(url, data);
    }

    function _getBaseUrl(accountId, campaignId, defaultPayoutId) {
      return campaignServiceNew.serviceBaseUrl(accountId, campaignId) + '/DefaultPayouts/' + (defaultPayoutId ? defaultPayoutId : '');
    }


  }
})();
